import { ActionInfoBase } from './object';

export class LoadSearchActionInfo extends ActionInfoBase {
  abort?: string;
  id?: string | number;
  query?: string;
}
export class LoadSearchActionSuccessInfo extends ActionInfoBase {
  id: string | number;
  searchResult: any[];
}
